import Rest from '../rest'

/******************************************************************************
 *  Customers
 *****************************************************************************/

/**
 * @type {Customer}
 */
export default class Customer extends Rest {

    constructor () {
        super('/customers')
    }

    getData(url, params) {
        return this.getAll(url, params)
    }

    readFilters() {
        return this.http.get(this.constructor.normalize(this.resource, '/get-activity-years-from-broker'))
            .then((response) => {
                const data = response.data.map((item) => {
                    item = { id: item.year, text: item.year }

                    return item
                })
                response.data = data

                return response
            });
    }

	filter(toFind, abortToken = null) {
		return this.http.get(this.constructor.normalize(this.resource, '/?q=' + toFind), 
		{
			cancelToken: abortToken
		})
	}
}